/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateResult } from '../../models/create-result';
import { SendInviteRequest } from '../../models/send-invite-request';

export interface ApiInvitesPost$Params {
      body?: SendInviteRequest
}

export function apiInvitesPost(http: HttpClient, rootUrl: string, params?: ApiInvitesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
  const rb = new RequestBuilder(rootUrl, apiInvitesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateResult>;
    })
  );
}

apiInvitesPost.PATH = '/api/Invites';
